/* eslint-disable prettier/prettier */
/* eslint-disable max-len */

/*
 * Copyright (c) 2023, WSO2 LLC. (http://www.wso2.com). All Rights Reserved.
 *
 * This software is the property of WSO2 LLC. and its suppliers, if any.
 * Dissemination of any information or reproduction of any material contained
 * herein is strictly forbidden, unless permitted by WSO2 in accordance with
 * the WSO2 Commercial License available at http://wso2.com/licenses.
 * For specific language governing the permissions and limitations under
 * this license, please see the license as well as any agreement you’ve
 * entered into with WSO2 governing the purchase of this software and any
 * associated services.
 */

import { createSvgIcon } from '@material-ui/core';
import * as React from 'react';

export default createSvgIcon(
  <path
    fill="currentColor"
    fillRule="evenodd"
    d="M12.8207.362a2.5897 2.5897 0 0 0-2.6414 0l-7.875 4.6572C1.4968 5.4967 1 6.3744 1 7.3236v9.3528c0 .9492.4968 1.8269 1.3043 2.3044l7.875 4.6571a2.5896 2.5896 0 0 0 2.6414 0l7.875-4.6571C21.5033 18.5032 22 17.6256 22 16.6764V7.3236c0-.9492-.4968-1.8269-1.3043-2.3044L12.8207.362ZM4.5849 7.9526c.2714-.4785.8733-.6429 1.3443-.3671L11.5 10.846l5.5707-3.2607c.471-.2757 1.0729-.1113 1.3444.3672.2714.4785.1095 1.09-.3615 1.3657l-5.5693 3.2597v6.3216c0 .5522-.4407.9999-.9843.9999-.5437 0-.9844-.4477-.9844-.9999v-6.3216L4.9463 9.3182c-.471-.2757-.6329-.8872-.3614-1.3657Z"
    clipRule="evenodd"
  />,
  'MenuProjectFilled'
);
